import React from 'react'

import { noLog as log } from '../../../shared/Utils'
import { Button, Dialog } from '@mote/ui'
import { useAccountUserManagementMutation } from '@mote/api'

export function UserControls({
  godModeOptions,
  pageIndex,
  afterUpdateCallback,
  userRow
}) {
  const [expanded, setExpanded] = React.useState(false)
  const [radioChoice, setRadioChoice] = React.useState('')

  const {
    mutate,
    loading: thinking,
    error
  } = useAccountUserManagementMutation()

  if (!userRow.userId) {
    return null
  }

  return (
    <form>
      <Button
        size='sm'
        onClick={() => setExpanded(prev => !prev)}
        text='Change'
      />

      <Dialog isOpen={expanded} onClose={() => _close()}>
        <Dialog.Heading>
          Update details for {userRow.primaryEmailAddress}{' '}
        </Dialog.Heading>

        <Dialog.Content>
          {_choice(
            'canMakeOwner',
            'makeOwner',
            'Make organization owner',
            'There can only be one organisational owner who receives billing communications. Only the owner can reassign ownership.'
          )}
          {_choice(
            'canMakeAdmin',
            'makeAdmin',
            'Enable user administration rights',
            'Allow more users to see this view and add/remove, upgrade/downgrade other users.'
          )}
          {_choice(
            'canUnmakeAdmin',
            'unmakeAdmin',
            'Disable user administration rights'
          )}
          {_choice(
            'canUpgradeToUnlimited',
            'upgradeToUnlimited',
            'Upgrade to Unlimited plan'
          )}

          {_choice(
            'canForceMinor',
            'makeMinor',
            'Force under 18 status',
            'Ensures that users override their under 18 status on login'
          )}
          {_choice('canUnforceMinor', 'makeAdult', 'Make 18+')}
          {_choice(
            'canDelicenseUser',
            'delicenseUser',
            'Remove allocated license',
            'Move use down to Free plan, freeing up one more seat for other users.'
          )}
          {_choice('canRemoveUser', 'removeUser', 'Remove user')}
        </Dialog.Content>
        <Dialog.ButtonGroup>
          <Button
            onClick={e => _applyAction(e)}
            disabled={!radioChoice}
            text={thinking ? 'Thinking...' : 'Update'}
            size='sm'
          />
          <Button
            text='Cancel'
            onClick={_close.bind(this)}
            variant='secondary'
            size='sm'
          />

          {error && (
            <p>
              <font color='red'>An error occurred, try again later</font>
            </p>
          )}
        </Dialog.ButtonGroup>
      </Dialog>
    </form>
  )

  function _choice(permission, path, label, tip) {
    if (userRow[permission]) {
      var key = permission + ' ' + path
      return (
        <p>
          <label>
            <input
              onChange={e => _radioChange(e)}
              checked={radioChoice === key}
              type='radio'
              value={key}
            />
            &nbsp;{label}{' '}
            {tip && (
              <span>
                <br />
                {tip}
              </span>
            )}
          </label>
        </p>
      )
    } else {
      return <React.Fragment />
    }
  }

  function _radioChange(e) {
    log('updating to ', e.target.value)
    setRadioChoice(e.target.value)
  }

  function _close() {
    setExpanded(false)
    setRadioChoice('')
  }

  async function _applyAction(e) {
    e.preventDefault()
    if (!radioChoice) {
      return
    }
    const [, path] = radioChoice.split(' ')

    const params = Object.assign({}, godModeOptions, {
      pageIndex,
      operatedUserId: userRow.userId
    })

    const res = await mutate({
      variables: params,
      routeOverride: `t/${path}`
    })

    if (res.error) return

    afterUpdateCallback(res.data)
  }
}
